<template>
  <el-dialog :visible.sync="visible" title="报表设置" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="是否隐藏得分情况：" prop="isWeekScore" label-width="150px" >
          <el-switch
                  v-model="dataForm.isWeekScore"
                  active-text="否" :active-value="0" active-color="red"
                  inactive-text="是" :inactive-value="1" inactive-color="#13ce66">
          </el-switch>
      </el-form-item>
      <el-form-item label="统计方式：" prop="statisticalMethods"  label-width="150px">
        <el-switch
                v-model="dataForm.statisticalMethods"
                active-text="统计所有记录" :active-value="1" active-color="#13ce66"
                inactive-text="不统计无图片和无视频的记录" :inactive-value="0" inactive-color="red">
        </el-switch>
      </el-form-item>
      <el-form-item label="是否自动统计优秀班级：" prop="isExcellentClass" label-width="200px">
        <el-switch
                v-model="dataForm.isExcellentClass"
                active-text="否" :active-value="0" active-color="red"
                inactive-text="是" :inactive-value="1" inactive-color="#13ce66">
        </el-switch>
      </el-form-item>
      <!-- v-if="$hasPermission('classEvaluate:changeReport')"
                            @change="getPage()" -->
      <el-form-item label="统计方式：" prop="gradeStatisticalMethods"  label-width="150px">

                    <el-switch
                            v-model="dataForm.gradeStatisticalMethods"
                            inactive-text="得分统计方式" :active-value="0" active-color="#13ce66"
                            active-text="评分统计方式" :inactive-value="1" inactive-color="red">
                    </el-switch>
      </el-form-item>
      <el-form-item label="是否展示一级标题：" prop="isShowTitle" label-width="150px">
        <el-switch
                v-model="dataForm.isShowTitle"
                active-text="否" :active-value="0" active-color="red"
                inactive-text="是" :inactive-value="1" inactive-color="#13ce66">
        </el-switch>
      </el-form-item>
      <!-- <el-form-item label="优秀班级获得规则：" prop="rank"  label-width="150px">
        <el-input v-model="dataForm.rank" type="number" placeholder="前几名"></el-input>
      </el-form-item> -->
      <el-form-item label="是否自定义表格标题：" prop="isCustomTitle" label-width="160px">
        <el-switch
                v-model="dataForm.isCustomTitle"
                active-text="否" :active-value="0" active-color="red"
                inactive-text="是" :inactive-value="1" inactive-color="#13ce66">
        </el-switch>
      </el-form-item>
      <!-- <el-form-item label="计算总分天数：" prop="scoreDays" label-width="150px">
        <el-switch
                v-model="dataForm.scoreDays"
                active-text="7天" :active-value="1" active-color="red"
                inactive-text="5天" :inactive-value="0" inactive-color="#13ce66">
        </el-switch>
      </el-form-item> -->
      <el-form-item label="计算总分天数：" prop="scoreDays" label-width="140px">
        <el-input v-model="dataForm.scoreDays" type="number" placeholder="自定义天数"></el-input>
      </el-form-item>
      <el-form-item label="自定义表格标题：" prop="customTitle" v-if="dataForm.isCustomTitle===1" label-width="140px">
        <el-input v-model="dataForm.customTitle" type="char" placeholder="自定义内容"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      num: 0,
      dataForm: {
        id: '',
        isWeekScore: 0,
        isShowTitle: '',
        gradeStatisticalMethods: '',
        scoreDays: '',
        isCustomTitle: '',
        customTitle: '',
        statisticalMethods: 0,
        isExcellentClass: 0,
        rank: '',
        createDate: '',
        updateDate: '',
        creator: '',
        schoolId: '',
        isScore: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        customTitle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.getInfo()
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/classEvaluate/weekScore/' + this.dataForm.schoolId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/classEvaluate/weekScore/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
